export default __webpack_public_path__ + "static/Image004-c1bafa03388351ffe3333d58e91ea8ee.webp";